import { render, staticRenderFns } from "./materialSelect.vue?vue&type=template&id=db3801ee&scoped=true&"
import script from "./materialSelect.vue?vue&type=script&lang=js&"
export * from "./materialSelect.vue?vue&type=script&lang=js&"
import style0 from "./materialSelect.vue?vue&type=style&index=0&id=db3801ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3801ee",
  null
  
)

export default component.exports